export default __webpack_public_path__ + "static/media/ml.98d768aa.svg";